<script>
import { defineAsyncComponent } from "@common/defineAsyncComponent";
import { componentStore } from "@common/componentStore/componentStore";
import { library } from "@common/library/library";

let vmsChangeMyRoleConfig = {
    cId: "vmsChangeMyRole",
    cType: "vmsChangeMyRole",
    cTitle: "Change My Role",
    cTemplate: `<div :id="wrapperID" class="vmsChangeMyRole-wrapper" :class="{'is-from-popup': isFromPopup}">
                    <div class="vmsChangeMyRole-title">Switch User Role</div>
                    <div class="vmsChangeMyRole-rolesWrapper">
                        <div class="vmsChangeMyRole-roleList-header">
                            <span>Role List</span>
                        </div>
                        <control name="ROLE_LIST" :items="roleList" class="vmsChangeMyRole-roleList-control"></control>
                    </div>
                    <div class="vmsChangeMyRole-buttons">
                        <div class="vmsChangeMyRole-button"><control name="CHANGE_MY_ROLE_OK_BUTTON"></control></div>
                        <div class="vmsChangeMyRole-button"><control name="CHANGE_MY_ROLE_CANCEL_BUTTON"></control></div>
                    </div>
               </div>
               `,
    controls: [
        {
            name: 'ROLE_LIST',
            type: 'list',
            onclick: 'selectRole',
            itemContentTemplate: `
                <div class="vmsChangeMyRole-clientRole">
                    <div class="vmsChangeMyRole-clientRole-cell">
                        <div class="vmsChangeMyRole-clientRole-cell-whiteSpace">
                            <div v-if="component.currentRoleId === data.roleID" class="vmsChangeMyRole-clientRole-cell-isActive"></div>
                        </div>
                        {{data.roleName}}
                    </div>
                </div>
                `,
            components: {
                "ejs-radiobutton": defineAsyncComponent(() => import('@common/syncfusion/radioButton')),
            }
        },
        {
            name: 'CHANGE_MY_ROLE_OK_BUTTON',
            type: 'button',
            label: 'OK',
            onclick: 'save',
        },
        {
            name: 'CHANGE_MY_ROLE_CANCEL_BUTTON',
            type: 'button',
            label: 'Cancel',
            onclick: 'close',
        },
    ]
};

let vmsChangeMyRoleCmp = {
    name: 'vmsChangeMyRole',
    preInitControls: true,
    props: {
        isFromPopup: {
            default: false
        }
    },
    data() {
        return {
            currentRoleId: null,
            roleList: []
        };
    },
    computed: {
        wrapperID() {
            return this.cId + 'Wrapper';
        },
    },
    components: {
        labelWrapper: defineAsyncComponent(() => import('@common/control/labelWrapper'))
    },
    methods: {
        onLoad() {
            this.$emit('update:vmsChangeMyRoleLoaded', true);
            library.showLoadingIndicator(this.wrapperID);
            this.sDs.post('ec_getRoles', false, true).then((response) => {
                if (response && response.status === 'success' && response.data) {
                    if (typeof response.data.clientRoleID !== 'undefined') {
                        this.currentRoleId = response.data.clientRoleID;
                    }
                    if (typeof response.data.roles === 'object') {
                        this.roleList = library.cloneObj(response.data.roles);
                    }
                }
                library.hideLoadingIndicator(this.wrapperID);
            });
        },
        selectRole: async function (roleInfo) {
            this.currentRoleId = roleInfo.roleID;
        },
        async save() {
            if (this.currentRoleId) {
                await actionStore.changeUserRole({ rowID: this.currentRoleId });
                library.removeSessionStorage('ecUserField');
                library.removeSessionStorage('ecUserProperty');
                setTimeout(() => {
                    location.reload();
                }, 500);
            }
            this.close();
        },
        close() {
            if (/openvmsChangeMyRole/g.test(window.name)) {
                window.close();
            } else {
                if (this.$parent && this.$parent.$parent && this.$parent.$parent.$parent && this.$parent.$parent.$parent.componentDialogs && this.$parent.$parent.$parent.componentDialogs[0] && this.$parent.$parent.$parent.componentDialogs[0].cancelButton) {
                    this.$parent.$parent.$parent.componentDialogs[0].cancelButton.click();
                }
            }
        }
    }
};

componentStore.initComponent(vmsChangeMyRoleCmp, vmsChangeMyRoleConfig);
export { vmsChangeMyRoleConfig, vmsChangeMyRoleCmp };
export default vmsChangeMyRoleCmp;
</script>

<style>
#dialog_container_openvmsChangeMyRole, #dialog_container_openvmsChangeMyRole > div {
    height: 400px;
}
.vmsChangeMyRole-title {
    font-size: 24px;
    font-weight: 600;
    text-align: center;
    color: #41362f;
}
.vmsChangeMyRole-rolesWrapper {
    margin-top: 20px;
    width: 100%;
}
.vmsChangeMyRole-roleList-header {
    background: #cfd8dc;
    padding: 5px;
}
.vmsChangeMyRole-roleList-header span {
    font-weight: bold;
    font-size: 13px;
    margin-left: 25px;
}
.vmsChangeMyRole-roleList-control {
    height: 250px;
    overflow-y: scroll
}
.vmsChangeMyRole-clientRole {
    width: 100%;
    min-height: 30px;
    padding: 5px;
    display: flex;
    font-size: 16px;
    cursor: pointer;
    border-bottom: 1px solid #dadce0;
}
.vmsChangeMyRole-clientRole:hover {
    background:#e8f0fe;
}
.vmsChangeMyRole-clientRole-cell {
    margin: 0 5px;
    display: inline-flex;
    align-items: center;
}
.vmsChangeMyRole-clientRole-cell-whiteSpace {
    width: 12px;
    margin-right: 10px;
}
.vmsChangeMyRole-clientRole-cell-isActive {
    width: 12px;
    height: 12px;
    background: #1976d2;
    border-radius: 50%;
}
</style>
<style scoped>
:deep(.vmsChangeMyRole-wrapper) {
    width: 100%;
    height: 400px;
    background-color: #fff;
    padding: 20px;
}
:deep(.is-from-popup) {
    width: 100%;
    height: 100%;
}
:deep(.vmsChangeMyRole-buttons) {
    text-align: center;
    margin-top: 20px;
    clear: both;
}
:deep(.vmsChangeMyRole-button) {
    display: inline-block;
    margin-left: 20px;
    width: 90px;
}
</style>
